import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-24d13208"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "holder"
};
const _hoisted_3 = {
  class: "breadcrumbs",
  itemscope: "",
  itemtype: "http://schema.org/BreadcrumbList"
};
const _hoisted_4 = {
  itemprop: "itemListElement",
  itemscope: "",
  itemtype: "http://schema.org/ListItem"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  itemprop: "name"
}, "Авторы", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "position",
  content: "1"
}, null, -1));

const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "author-about"
};
const _hoisted_9 = {
  class: "author-about-img"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "author-about-content"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "show-more-hidden"
}, null, -1));

const _hoisted_13 = {
  key: 0,
  class: "author-works"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, "Работы", -1));

const _hoisted_15 = {
  class: "catalog"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_WorkCardComponent = _resolveComponent("WorkCardComponent");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ol", _hoisted_3, [_createElementVNode("li", _hoisted_4, [_createVNode(_component_router_link, {
    itemprop: "item",
    to: {
      name: 'authors'
    },
    style: {
      "cursor": "pointer"
    }
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _hoisted_6]), _createElementVNode("li", null, [_createElementVNode("span", null, _toDisplayString($data.Author.name), 1)])]), _createElementVNode("h2", _hoisted_7, _toDisplayString($data.Author.name) + " " + _toDisplayString($options.dateLife), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: $data.Author.thumbWithPath,
    alt: ""
  }, null, 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.description, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      key: index
    }, _toDisplayString(item), 1);
  }), 128)), _hoisted_12, $data.moreBlock ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    href: "",
    class: "show-more",
    onClick: _cache[0] || (_cache[0] = $event => $data.fullDesc = !$data.fullDesc)
  }, "Читать больше")) : _createCommentVNode("", true)])]), $data.Author.works && $data.Author.works.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, [_createVNode(_component_WorkCardComponent, {
    works: $data.Author.works
  }, null, 8, ["works"])])])) : _createCommentVNode("", true)])]);
}